import { Injectable } from "@angular/core";

@Injectable()
export class NewPasswordUser {
    username: string;
    existingPassword: string;
    password: string;
}
